const COLORS = {
  PRIMARY_COLOR: "#3053e4",
  SECONDARY_COLOR: "#bbc4e5",
  THIRD_COLOR: "#5470e4",
  ROBIN_EGG: "#66f3ff",
  DARK: "#2a3049",
  ORANGE_YELLOW: "#fbae17",
  BLACK: "#231f20",
  BACKGROUND_COLOR: "#f8f8f8",
};

export default COLORS;